import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initForm, setFiltro, salvar, excluir, getListaEntrega, salvarCodigoSM, setDialogCodigoSM, setFormPedido,
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida, alterarViagemKm, getLinkRastreio,
	getListaNotificacaoPedido,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

class PedidoEntrega extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.getListaEntrega(this.props.filtro.data_inicial, this.props.filtro.data_final);
		this.props.getListaDistribuidora();
		this.props.getListaPoliticaPreco();
		this.props.getListaUnidade();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaProduto();
		this.props.getListaCustoPrazo();
		this.props.verificaEstoqueManual();
		this.props.verificaAbastecida();
		this.props.getListaPedidoTipo();
		this.props.getListaPedidoFrete();
		this.props.getListaPedidoCnpj();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			if (this.props.modoTela == 'lista') {
				this.props.getListaEntrega(this.props.filtro.data_inicial, this.props.filtro.data_final);
			}
			this.props.getListaDistribuidora();
			this.props.getListaPoliticaPreco();
			this.props.getListaUnidade();
			this.props.getListaMotorista();
			this.props.getListaVeiculo();
			this.props.getListaCliente();
			this.props.getListaEndereco();
			this.props.getListaProduto();
			this.props.getListaCustoPrazo();
			this.props.verificaEstoqueManual();
			this.props.verificaAbastecida();
			this.props.getListaPedidoPrazo();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {

		if (false && !this.props.estoqueManualLancado) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance o estoque físico de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}
		if (!this.props.abastecidaLancada) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance as abastecidas de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}
		
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				
				{this.props.dialogPedido ? this.modalCodigoSM() : null}
				{this.modalKm()}
				{this.modalNotificacoes()}

				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_inicial}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_final}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaUnidade.filter(item => (this.props.filtro.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_unidades: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaCliente}
							label='Cliente'
							cols='12 6 3 3'
							maxWidth={300}
							placeholder='Selecione'
							multiple
							value={this.props.listaCliente.filter(item => (this.props.filtro.ids_clientes || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_clientes: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaMotorista}
							label='Motorista'
							cols='12 6 3 3'
							placeholder='Selecione'
							maxWidth={220}
							multiple
							value={this.props.listaMotorista.filter(item => (this.props.filtro.ids_motoristas || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_motoristas: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							maxWidth={220}
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.props.filtro.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_veiculos: (values || []).map(item => item.value) });
							}} />

						<Grid cols='6 6 4 2' style={{ paddingTop: 28, maxWidth: 140 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getListaEntrega(this.props.filtro.data_inicial, this.props.filtro.data_final);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>

				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data</Th>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Motorista</Th>
								<Th alignCenter>Placa</Th>
								<Th alignCenter>Vendedor</Th>
								<Th alignCenter>Clientes</Th>
								<Th alignCenter>Finalizado Base</Th>
								<Th alignCenter>Início Viagem</Th>
								<Th alignCenter>Fim Viagem</Th>
								<Th alignCenter>Km Início</Th>
								<Th alignCenter>Km Fim</Th>
								<Th alignCenter>Km Previsto</Th>
								<Th alignCenter>Km Rodado</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaEntrega.filter(item => {
								if (this.state.pesquisar
									&& !(`${DateFormat.formatarDataSqlParaTela(item.data_pedido)} ${item.nome_status} ${item.clientes}
										${item.giro} ${item.nome_motorista} ${item.placa_veiculo} ${item.nome_usuario_inclusao}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).filter(item => 
								item.id_status == 3 || item.id_status == 7
							).filter(item => 
								item.id_usuario_inclusao == (this.props.sessao ? this.props.sessao.id : 0)
									|| (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_pedido_aprovacao)
							).filter(item => {
								if ((this.props.filtro.ids_unidades || []).length && !(this.props.filtro.ids_unidades || []).includes(item.id_unidade)) {
									return false;
								}
								if ((this.props.filtro.ids_clientes || []).length && !(item.itens || []).filter(cli => cli && (this.props.filtro.ids_clientes || []).includes(cli.id_cliente)).length) {
									return false;
								}
								if ((this.props.filtro.ids_motoristas || []).length && !(this.props.filtro.ids_motoristas || []).includes(item.id_motorista)) {
									return false;
								}
								if ((this.props.filtro.ids_veiculos || []).length && !(this.props.filtro.ids_veiculos || []).includes(item.id_veiculo)) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.id}
									backgroundColor={
										item.datahora_fim_retorno ? '#5dc763' : (
											item.datahora_inicio_retorno ? '#778ced' : (
												item.datahora_fim_entrega ? '#f2ec3d' : (
													item.datahora_inicio_entrega ? '#f2aa2e' : '#d17c73'
												)
											)
										)
									} >
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_pedido)}</Td>
									<Td alignCenter>{item.giro}</Td>
									<Td alignCenter>{item.datahora_fim_retorno ? 'Finalizada' : (
										item.datahora_inicio_retorno ? 'Retornando' : (
											item.datahora_fim_entrega ? 'Entregue' : (
												item.datahora_inicio_entrega ? 'Em Entrega' : 'Não Iniciada'
											)
										)
									)}</Td>
									<Td alignCenter>{item.nome_motorista}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.nome_usuario_inclusao}</Td>
									<Td alignCenter>{item.clientes}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_entrega)}</Td>
									<Td alignCenter>
										{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio_viagem || item.datahora_inicio_entrega)}
									</Td>
									<Td alignCenter>
										{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim_viagem || item.datahora_fim_retorno)}
									</Td>
									<Td alignCenter>{item.km_inicio_viagem ? FormatUtils.formatarValorTela(item.km_inicio_viagem, 0) : '-'}</Td>
									<Td alignCenter>{item.km_fim_viagem ? FormatUtils.formatarValorTela(item.km_fim_viagem, 0) : '-'}</Td>
									<Td alignCenter>{item.distancia ? FormatUtils.formatarValorTela(item.distancia, 0) : '-'}</Td>
									<Td alignCenter
										title={
											`Km Inicial: ${FormatUtils.formatarValorTela(item.km_inicio_viagem, 0)}\n`
											+ `Km Fim: ${FormatUtils.formatarValorTela(item.km_fim_viagem, 0)}`
										}>{item.km_rodado ? FormatUtils.formatarValorTela(item.km_rodado, 0) : '-'}</Td>
									<Td alignRight minWidth={100}>
										<div style={{ display: 'flex', padding: 2 }}>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-comments'}
												visible={true}
												event={() => {
													this.setState({
														...this.state,
														modalNotificacoes: {
															...item
														}
													});	
													this.props.getListaNotificacaoPedido({ ...item });											
												}} />
											<ButtonTable
												type={'primary'}
												icon={'fas fa-road'}
												visible={true}
												event={() => {
													this.setState({
														...this.state,
														modalKm: {
															...item,
															km_inicio_viagem: item.km_inicio_viagem ? FormatUtils.formatarValorTela(item.km_inicio_viagem, 0) : '',
															km_fim_viagem: item.km_fim_viagem ? FormatUtils.formatarValorTela(item.km_fim_viagem, 0) : ''
														}
													});												
												}} />
										</div>
										
										<div style={{ display: 'flex', padding: 2 }}>
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												event={() => {
													
													this.props.setFormPedido('pedidoEntrega', 'visualizacao', item);

													// this.props.setModoTela('visualizacao', {
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
													// this.props.initForm({
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
												}} />

											<ButtonTable
												type={'primary'}
												icon={'fas fa-download'}
												visible={true}
												event={() => {
													this.props.gerarOrcamento(item);
												}} />
										</div>

										<div style={{ display: 'flex', padding: 2 }}>
											<ButtonTable
												type={'success'}
												icon={'fab fa-whatsapp'}
												visible={true}
												
												title={item.celular_motorista ? 'Mensagem para motorista' : 'Sem motorista ou motorista sem celular configurado'}
												event={() => {

													let mensagem = `*Giro**:* *${item.giro}*\n`;
													mensagem += `Placa: ${item.placa_veiculo}\n`;
													mensagem += `Entregas:\n`;
													(item.itens || []).forEach((pedidoItem, i) => {													
														mensagem += `  *Pedido* *${i + 1}**:*\n`;
														mensagem += `  Cliente: ${pedidoItem.nome_cliente}\n`;
														mensagem += `  Endereço: ${pedidoItem.nome_endereco}\n`;
														mensagem += `  Produto: ${pedidoItem.nome_produto}\n`;
														mensagem += `  Quantidade: ${FormatUtils.formatarValorTela(pedidoItem.quantidade, 2)}\n`;
														mensagem += `  Obs: ${pedidoItem.observacao}\n\n`;
													});
													if (item.rota_link) {
														mensagem += `Link: ${item.rota_link}`;
													}
													window.open(`https://api.whatsapp.com/send?phone=+55${item.celular_motorista}&text=${encodeURI(mensagem)}`, '_blank');
											
												}} />
											</div>
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalCodigoSM() {

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Rastreamento</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.props.setDialogCodigoSM(null)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								<LabelAndInputNumber
									label='Código SM Ida' 
									placeholder='Informe o código'
									cols='12 12 12 12'
									casas={0}
									value={this.props.dialogPedido.codigo_sm_entrega}
									onChange={data => {
										this.props.setDialogCodigoSM({
											...this.props.dialogPedido,
											codigo_sm_entrega: data.target.value
										});
									}} />

								<LabelAndInputNumber
									label='Código SM Volta' 
									placeholder='Informe o código'
									cols='12 12 12 12'
									casas={0}
									value={this.props.dialogPedido.codigo_sm_retorno}
									onChange={data => {
										this.props.setDialogCodigoSM({
											...this.props.dialogPedido,
											codigo_sm_retorno: data.target.value
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.props.salvarCodigoSM({
										id: this.props.dialogPedido.id,
										codigo_sm_entrega: this.props.dialogPedido.codigo_sm_entrega ? FormatUtils.formatarValorBanco(this.props.dialogPedido.codigo_sm_entrega, 0) : null,
										codigo_sm_retorno: this.props.dialogPedido.codigo_sm_retorno ? FormatUtils.formatarValorBanco(this.props.dialogPedido.codigo_sm_retorno, 0) : null,
									});
									this.props.setDialogCodigoSM(null);
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalKm() {

		if (!this.state.modalKm) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Viagem</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalKm: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Row alignCenter>
								<LabelAndInputNumber
									label={'Km Inicial'}
									placeholder=''
									cols='12 4 4 4'
									casas={0}
									value={this.state.modalKm.km_inicio_viagem}
									onChange={data => {
										this.setState({
											...this.state,
											modalKm: {
												...this.state.modalKm,
												km_inicio_viagem: data.target.value
											}
										});	
									}} />
							</Row>
							<Row alignCenter>
								<LabelAndInputNumber
									label={'Km Final'}
									placeholder=''
									cols='12 4 4 4'
									casas={0}
									value={this.state.modalKm.km_fim_viagem}
									onChange={data => {
										this.setState({
											...this.state,
											modalKm: {
												...this.state.modalKm,
												km_fim_viagem: data.target.value
											}
										});
									}} />
							</Row>

							<Row alignCenter>
								<Grid cols='12 6 4 4'>
									<button 
										type='button'
										class='btn btn-block btn-success btn-lg'
										onClick={() => {

											let registro = {
												...this.state.modalKm
											};

											registro = {
												...registro,
												datahora_inicio_viagem: parseInt(FormatUtils.formatarValorBanco(this.state.modalKm.km_inicio_viagem, 0)) > 0 
													? (this.state.modalKm.datahora_inicio_viagem || DateFormat.getDataHoraAtual()) 
													: null,
												id_usuario_inicio_viagem: parseInt(FormatUtils.formatarValorBanco(this.state.modalKm.km_inicio_viagem, 0)) > 0 
													? 	(this.state.modalKm.id_usuario_inicio_viagem || this.props.sessao.id) 
													: 	null,
												datahora_fim_viagem: parseInt(FormatUtils.formatarValorBanco(this.state.modalKm.km_fim_viagem, 0)) > 0 
													? (this.state.modalKm.datahora_fim_viagem || DateFormat.getDataHoraAtual()) 
													: null,
												id_usuario_fim_viagem: parseInt(FormatUtils.formatarValorBanco(this.state.modalKm.km_fim_viagem, 0)) > 0 
													? 	(this.state.modalKm.id_usuario_fim_viagem || this.props.sessao.id) 
													: 	null,
											};

											this.props.alterarViagemKm(registro, () => {
												this.setState({
													...this.state,
													modalKm: null
												});	
												this.props.getListaEntrega(this.props.filtro.data_inicial, this.props.filtro.data_final);
											});
											
										}}>
										Salvar
									</button>
								</Grid>
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalNotificacoes() {

		if (!this.state.modalNotificacoes) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl' style={{ width: '95%', maxWidth: '95%' }}>
					<div class='modal-content' style={{ width: '100%' }}>
						<div class='modal-header'>
							<h4 class='modal-title'>Giro {this.state.modalNotificacoes.giro}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalNotificacoes: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Table responsive border>
								<THead>
									<Tr>
										<Th rowspan={2} alignCenter>Item</Th>
										<Th rowspan={2} alignCenter>Endereço</Th>
										<Th rowspan={2} width={10} alignCenter>Rastreio</Th>
										<Th rowspan={2} alignCenter>Produto</Th>
										<Th rowspan={2} alignCenter>Quantidade</Th>
										<Th rowspan={2} alignCenter>Previsão</Th>
										<Th rowspan={2} alignCenter>Realizado</Th>
										<Th rowspan={2} alignCenter>Odômetro</Th>
										<Th rowspan={2} alignCenter>Km Rodado</Th>
										<Th rowspan={2} alignCenter>WhatsApp</Th>
										<Th colspan={3} alignCenter>Notificação</Th>
									</Tr>
									<Tr>
										<Th alignCenter>Faturado</Th>
										<Th alignCenter>Em Rota</Th>
										<Th alignCenter>Chegada</Th>
									</Tr>
								</THead>
								<TBody>
									<Tr>
										<Td alignCenter small bold>Início da Viagem</Td>
										<Td alignCenter small title='Local'>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
												Local
												{(this.state.modalNotificacoes.latitude_origem_viagem && this.state.modalNotificacoes.longitude_origem_viagem
												&& this.state.modalNotificacoes.tracking_latitude_inicio && this.state.modalNotificacoes.tracking_longitude_inicio) &&
												<a 
													href={`https://www.google.com/maps/dir/${this.state.modalNotificacoes.tracking_latitude_inicio},${this.state.modalNotificacoes.tracking_longitude_inicio}/${this.state.modalNotificacoes.latitude_origem_viagem},${this.state.modalNotificacoes.longitude_origem_viagem}`}
													target='blank' class='text-muted'
													style={{ marginLeft: 8, fontSize: 18 }}>
													<i class='fas fa-map-marker-alt'></i>
												</a>}
											</div>
										</Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small bold>{DateFormat.formatarDataHoraSqlParaTela(this.state.modalNotificacoes.tracking_datahora_inicio)}</Td>
										<Td alignCenter small bold>{this.state.modalNotificacoes.tracking_odometro_inicio ? FormatUtils.formatarValorTelaDecimal(this.state.modalNotificacoes.tracking_odometro_inicio, 0) : ''}</Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
									</Tr>
									{this.props.listaPedidoNotificacao.map(item => {
										
										let statusFaturadoCor = '';
										let statusFaturadoIcone = '';
										if (item.status_notificacao_faturado == 'Sem Notificação') {
											statusFaturadoCor = '#827e7e';
											statusFaturadoIcone = 'fas fa-times';
										} else if (item.status_notificacao_faturado == 'Aguardando Envio') {
											statusFaturadoCor = '#2866d1';
											statusFaturadoIcone = 'fas fa-clock';
										} else if (item.status_notificacao_faturado == 'Enviado') {
											statusFaturadoCor = '#2f6100';
											statusFaturadoIcone = 'fas fa-check-double';
										} else if (item.status_notificacao_faturado == 'Não Enviado') {
											statusFaturadoCor = '#cf1c00';
											statusFaturadoIcone = 'fas fa-exclamation-circle';
										}

										let statusRotaCor = '';
										let statusRotaIcone = '';
										if (item.status_notificacao_rota == 'Sem Notificação') {
											statusRotaCor = '#827e7e';
											statusRotaIcone = 'fas fa-times';
										} else if (item.status_notificacao_rota == 'Aguardando Envio') {
											statusRotaCor = '#2866d1';
											statusRotaIcone = 'fas fa-clock';
										} else if (item.status_notificacao_rota == 'Enviado') {
											statusRotaCor = '#2f6100';
											statusRotaIcone = 'fas fa-check-double';
										} else if (item.status_notificacao_rota == 'Não Enviado') {
											statusRotaCor = '#cf1c00';
											statusRotaIcone = 'fas fa-exclamation-circle';
										}

										let statusChegadaCor = '';
										let statusChegadaIcone = '';
										if (item.status_notificacao_chegada == 'Sem Notificação') {
											statusChegadaCor = '#827e7e';
											statusChegadaIcone = 'fas fa-times';
										} else if (item.status_notificacao_chegada == 'Aguardando Envio') {
											statusChegadaCor = '#2866d1';
											statusChegadaIcone = 'fas fa-clock';
										} else if (item.status_notificacao_chegada == 'Enviado') {
											statusChegadaCor = '#2f6100';
											statusChegadaIcone = 'fas fa-check-double';
										} else if (item.status_notificacao_chegada == 'Não Enviado') {
											statusChegadaCor = '#cf1c00';
											statusChegadaIcone = 'fas fa-exclamation-circle';
										}

										return (
											<Tr key={item.id}>
												<Td alignCenter small>{item.nome_cliente}</Td>
												<Td alignCenter small title='Local'>
													<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
														{item.nome_endereco}
														{(item.latitude && item.longitude
														&& item.tracking_latitude_chegada && item.tracking_longitude_chegada) &&
														<a 
															href={`https://www.google.com/maps/dir/${item.tracking_latitude_chegada},${item.tracking_longitude_chegada}/${item.latitude},${item.longitude}`}
															target='blank' class='text-muted'
															style={{ marginLeft: 8, fontSize: 18 }}>
															<i class='fas fa-map-marker-alt'></i>
														</a>}
													</div>
												</Td>
												<Td width={10} alignCenter small title='Link do Rastreio'>
													<ButtonTable
														type={'primary'}
														icon={'fas fa-route'}
														visible={true}
														event={() => {
															this.props.getLinkRastreio(item.id_pedido, item.id_endereco);
														}} />
												</Td>
												<Td alignCenter small>{item.nome_produto}</Td>
												<Td alignCenter small>{FormatUtils.formatarValorTelaDecimal(item.quantidade, 0)}</Td>
												<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrega)}</Td>
												<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.tracking_datahora_chegada)}</Td>
												<Td alignCenter small>{item.tracking_odometro_chegada != null ? FormatUtils.formatarValorTelaDecimal(item.tracking_odometro_chegada, 0) : ''}</Td>
												<Td alignCenter small>{item.tracking_odometro_chegada != null ? FormatUtils.formatarValorTelaDecimal(item.km_rodado, 0) : ''}</Td>
												<Td alignCenter small>{item.celular}</Td>
												<Td alignCenter small>
													<div style={{ display: 'flex', flexDirection: 'column' }} 
														title={item.datahora_notificacao_faturado ? `${DateFormat.formatarDataHoraSqlParaTela(item.datahora_notificacao_faturado)}: ${item.retorno_notificacao_faturado}` : ''}>
														<i class={statusFaturadoIcone} style={{ color: statusFaturadoCor, fontSize: 16 }}></i>
														<div style={{ height: 32, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item.status_notificacao_faturado}</div>
													</div>
												</Td>
												<Td alignCenter small>
													<div style={{ display: 'flex', flexDirection: 'column' }} 
														title={item.datahora_notificacao_rota ? `${DateFormat.formatarDataHoraSqlParaTela(item.datahora_notificacao_rota)}: ${item.retorno_notificacao_rota}` : ''}>
														<i class={statusRotaIcone} style={{ color: statusRotaCor, fontSize: 16 }}></i>
														<div style={{ height: 32, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item.status_notificacao_rota}</div>
													</div>
												</Td>
												<Td alignCenter small>
													<div style={{ display: 'flex', flexDirection: 'column' }} 
														title={item.datahora_notificacao_chegada ? `${DateFormat.formatarDataHoraSqlParaTela(item.datahora_notificacao_chegada)}: ${item.retorno_notificacao_chegada}` : ''}>
														<i class={statusChegadaIcone} style={{ color: statusChegadaCor, fontSize: 16 }}></i>
														<div style={{ height: 32, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item.status_notificacao_chegada}</div>
													</div>
												</Td>
											</Tr>
										);
									})}
									<Tr>
										<Td alignCenter small bold>Final da Viagem</Td>
										<Td alignCenter small title='Local'>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
												Local
												{(this.state.modalNotificacoes.latitude_destino_viagem && this.state.modalNotificacoes.longitude_destino_viagem
												&& this.state.modalNotificacoes.tracking_latitude_fim && this.state.modalNotificacoes.tracking_longitude_fim) &&
												<a 
													href={`https://www.google.com/maps/dir/${this.state.modalNotificacoes.tracking_latitude_fim},${this.state.modalNotificacoes.tracking_longitude_fim}/${this.state.modalNotificacoes.latitude_destino_viagem},${this.state.modalNotificacoes.longitude_destino_viagem}`}
													target='blank' class='text-muted'
													style={{ marginLeft: 8, fontSize: 18 }}>
													<i class='fas fa-map-marker-alt'></i>
												</a>}
											</div>
										</Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small bold>{DateFormat.formatarDataHoraSqlParaTela(this.state.modalNotificacoes.tracking_datahora_fim)}</Td>
										<Td alignCenter small bold>{this.state.modalNotificacoes.tracking_odometro_fim ? FormatUtils.formatarValorTelaDecimal(this.state.modalNotificacoes.tracking_odometro_fim, 0) : ''}</Td>
										<Td alignCenter small bold>{this.state.modalNotificacoes.tracking_odometro_inicio && this.state.modalNotificacoes.tracking_odometro_fim 
											? FormatUtils.formatarValorTelaDecimal(parseInt(this.state.modalNotificacoes.tracking_odometro_fim) - parseInt(this.state.modalNotificacoes.tracking_odometro_inicio), 0)
											: ''
										}</Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
										<Td alignCenter small></Td>
									</Tr>
								</TBody>
							</Table>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	filtro: state.pedido.filtro,
	listaEntrega: state.pedido.listaEntrega,
	dialogPedido: state.pedido.dialogPedido,
	estoqueManualLancado: state.pedido.estoqueManualLancado,
	abastecidaLancada: state.pedido.abastecidaLancada,
	listaPedidoNotificacao: state.pedido.listaPedidoNotificacao,
	listaUnidade: state.pedido.listaUnidade,
	listaCliente: state.pedido.listaCliente,
	listaMotorista: state.pedido.listaMotorista,
	listaVeiculo: state.pedido.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, salvar, excluir, getListaEntrega, salvarCodigoSM, setDialogCodigoSM, setFormPedido,
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida, alterarViagemKm, getLinkRastreio,
	getListaNotificacaoPedido,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoEntrega);
